import { reloadCustomMetricGroupsByInitiativeId } from '@actions/initiative';
import { useRegenerateMetricGroupUtrsMutation } from '@api/metric-groups';
import { generateErrorToast, generateToast } from '@g17eco/molecules/toasts';
import { MetricGroup } from '@g17eco/types/metricGroup';
import { useAppDispatch } from '@reducers/index';

export const useRegenerateMetricGroup = ({ callback }: { callback?: () => void } = {}) => {
  const dispatch = useAppDispatch();
  const [regenerateMetricGroupUtrs] = useRegenerateMetricGroupUtrsMutation();

  const handleRegenerate = (metricGroup: MetricGroup, topTopicsCount: number | undefined) => {
    if (!topTopicsCount) {
      return;
    }

    regenerateMetricGroupUtrs({ initiativeId: metricGroup.initiativeId, groupId: metricGroup._id, topTopicsCount })
      .unwrap()
      .then(() => {
        generateToast({
          color: 'success',
          message: 'Module regenerated successfully',
        });
        dispatch(reloadCustomMetricGroupsByInitiativeId(metricGroup.initiativeId));
        callback?.();
      })
      .catch((error) => {
        generateErrorToast(error);
      });
  };

  return { handleRegenerate };
};
